import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./scss/inventory.scss";
import { INVENTORY } from "../../constants/route-paths";
import {
  getPOList,
  updatePOStock,
  getProjectList,
  getPoVendors,
  getDePOList,
} from "../../actions/project-management.action";
import {
  listCategories,
  getItems,
  addNoPoStock,
} from "../../actions/inventory.action";

import { warningSnackBar } from "../../actions/common.action";
import _ from "lodash";
import idx from "idx";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Button from 'react-bootstrap/Button';
import SelectInput from "../../components/inputs/select";
import CustomInput from "../../components/inputs/new-input";
import { useNavigate } from "react-router";
import { sortByKeyAsc } from "src/util/common";
import CustomTable from '../../components/table/table';
import Cookies from "js-cookie";

export default function AddStock(props) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const user = useSelector(state => state.user.userData)
  const categoryList = useSelector(state => state.catalog.catalogs)

  const [state, setState] = useState({
    POList: [],
    items: [], // Displayed items
    allItems: [], // All items for PO mode
    categories: [],
    poId: "",
    limit: 25,
    offset: 0,
    currentPage: 1,
    totalCount: 0,
    isLoading: false,
    search: "",
  })
  const [fields, setFields] = useState({
    type: {
      name: "type",
      label: "Project",
      type: "select",
      touched: false,
      error: false,
      valid: true,
      value: "project",
      items: [{ key: "Project", value: "project" }],
      validation: [],
    },
    project: {
      name: "project",
      label: "Select Project",
      type: "select",
      touched: false,
      error: false,
      valid: true,
      value: "",
      items: [],
      validation: [],
    },
    vendor: {
      name: "vendor",
      label: "Select Vendor",
      type: "select",
      touched: false,
      error: false,
      valid: true,
      value: "",
      items: [],
      validation: [],
    },
    location: {
      name: "location",
      label: "Store location",
      type: "select",
      touched: false,
      error: false,
      valid: true,
      value: "",
      items: [
        { key: "Site", value: "SITE" },
        { key: "WareHouse", value: "WAREHOUSE" },
      ],
      validation: ["required"],
    },
    category: {
      name: "category",
      label: "Select Catalog",
      type: "select",
      touched: false,
      error: false,
      valid: true,
      value: "",
      items: [],
      validation: ["required"],
    },
    po: {
      name: "po",
      label: "Select PO",
      type: "select",
      touched: false,
      error: false,
      valid: true,
      value: "",
      items: [
        { key: "No PO", value: "NO_PO" },
        { key: "Internal PO", value: "DE_PO" },
      ],
      validation: ["required"],
    },
    dePurchaseOrder: {
      name: "dePurchaseOrder",
      label: "Select Internal PO",
      type: "select",
      touched: false,
      error: false,
      valid: true,
      value: "",
      items: [],
      validation: ["required"],
    },

  })

  useEffect(() => {
    init();
    if (categoryList.length == 0) dispatch(listCategories())

    const recordsPerPage = Cookies.get("recordsPerPage")
      ? parseInt(Cookies.get("recordsPerPage"))
      : 25;
    setState(prev => ({ ...prev, limit: recordsPerPage }));
  }, [])

  useEffect(() => {
    const categories = [];
    Array.isArray(categoryList) && categoryList.forEach((category) =>
      categories.push({ key: category.name, value: category.id })
    );
    setFields(prev => ({
      ...prev,
      category: { ...prev.category, items: categories },
    }));
  }, [categoryList])

  const init = () => {
    typeChangeHandler({ target: { name: 'type', value: "project" } });
  }

  const inputChangeHandler = (e) => {
    if (!_.isObject(e)) return;
    let name = e.target.name;
    let value = e.target.value

    const { error, valid } = handleValidation(e.target, fields[name].validation);

    setFields(prev => ({
      ...prev,
      [name]: {
        ...prev[name],
        value: value,
        touched: true,
        error: error,
        valid: valid,
      },
    }));
  };

  const handleValidation = ({ name, type, value }, validation) => {
    let error = false;
    let valid = true;
    if (
      validation.includes("required") && (value === undefined ||
        (!_.isBoolean(value) && !_.isNumber(value) && value.trim() === ""))
    ) {
      return { error: "This Field is Required", valid: false };
    }
    return { error, valid };
  };

  const typeChangeHandler = async (e) => {
    if (!_.isObject(e)) return;
    inputChangeHandler(e);
    let projectsList = await dispatch(getProjectList('', 'PROJECT')).catch(e => console.error(e));

    let projects = (Array.isArray(projectsList) && projectsList.map((project) => {
      return {
        key: project.name.trim(),
        value: project.id,
      };
    })) || [];

    projects = _.orderBy(projects, [({ key }) => key.toLowerCase()], ["asc"]);

    setFields(prev => ({
      ...prev,
      project: { ...prev.project, items: projects, value: '' },
      vendor: { ...prev.vendor, value: '' },
    }));
  };

  const changePOType = async (e) => {
    const name = e.target.name;
    const value = e.target.value;

    let categoryVaidation = [], dePOValidation = [], dePOItems = [], items = [];
    if (value === "NO_PO") {
      categoryVaidation = ["required"];
    } else if (value === "DE_PO") {
      dePOValidation = ["required"];
      const dePOList = await dispatch(getDePOList()).catch(e => console.error(e));
      let list = dePOList.map(({ id, items }) => ({
        key: id,
        value: id,
        items,
      }));
      dePOItems = _.orderBy(list, ["key"], ["desc"]);
    } else {
      const POData = fields.po.items.find((po) => po.value === value);
      if (POData) {
        Array.isArray(POData.items) && POData.items.forEach((item) => {
          items.push({
            ...item,
            receivedQty: item.receivedQty ? item.receivedQty : 0,
          });
        });
      }
    }

    setFields(prev => ({
      ...prev,
      category: { ...prev.category, validation: categoryVaidation },
      dePurchaseOrder: {
        ...prev.dePurchaseOrder,
        validation: dePOValidation,
        ...(value === "DE_PO" ? { items: dePOItems } : {})
      },
    }));

    // For PO modes, we set allItems and then slice for display
    const isPO = value !== "NO_PO";

    setState(prev => {
      const newState = {
        ...prev,
        allItems: isPO ? items : [],
        items: isPO ? items.slice(0, prev.limit) : [],
        poId: value,
        totalCount: isPO ? items.length : 0,
        currentPage: 1,
        offset: 0
      };
      return newState;
    });

    inputChangeHandler({ target: { name, value } })
  };

  const changeDePo = (e) => {
    const value = e.target.value;
    inputChangeHandler(e);
    const POData = fields.dePurchaseOrder.items.find((po) => po.value === value);
    const items = [];
    if (POData) {
      Array.isArray(POData.items) && POData.items.forEach((item) => {
        items.push({
          ...item,
          receivedQty: item.receivedQty ? item.receivedQty : 0,
        });
      });
    }
    setState(prev => ({
      ...prev,
      allItems: items,
      items: items.slice(0, prev.limit),
      totalCount: items.length,
      currentPage: 1,
      offset: 0
    }));
  };

  useEffect(() => {
    const { selectedCategory, limit, offset, poId, search } = state;
    if (poId === "NO_PO") {
      if (selectedCategory) {
        setState(prev => ({ ...prev, isLoading: true }));

        dispatch(getItems({ categoryId: selectedCategory, limit, offset, search })).then((response) => {
          let items = [];
          let totalCount = 0;

          if (Array.isArray(response)) {
            items = response;
            totalCount = response.length;
          } else if (response && response.items) {
            items = response.items;
            totalCount = response.totalCount;
          }

          setState(prev => ({
            ...prev,
            items,
            totalCount,
            isLoading: false,
          }));
        }).catch(() => {
          setState(prev => ({ ...prev, isLoading: false }));
        });
      } else {
        setState(prev => ({
          ...prev,
          items: [],
          totalCount: 0,
          isLoading: false,
        }));
      }
    }
  }, [state.selectedCategory, state.limit, state.offset, state.poId, state.search]);

  const changeCategory = (e) => {
    const categoryId = e.target.value;
    inputChangeHandler(e);
    setState(prev => ({
      ...prev,
      selectedCategory: categoryId,
      offset: 0,
      currentPage: 1,
    }));
  };

  const ignoreNextPageChange = React.useRef(false);

  const handlePageChange = (page, limit) => {
    if (ignoreNextPageChange.current) {
      ignoreNextPageChange.current = false;
      return;
    }
    const offset = (page - 1) * limit;

    setState(prev => {
      const newState = {
        ...prev,
        currentPage: page,
        offset,
        limit,
      };

      if (prev.poId !== "NO_PO") {
        // Client-side pagination for PO
        newState.items = prev.allItems.slice(offset, offset + limit);
      }

      return newState;
    });
  };

  const handleLimitChange = (limit) => {
    ignoreNextPageChange.current = true;
    setState(prev => {
      const newState = {
        ...prev,
        limit,
        offset: 0,
        currentPage: 1,
      };

      if (prev.poId !== "NO_PO") {
        // Client-side pagination for PO
        newState.items = prev.allItems.slice(0, limit);
      }

      return newState;
    });
  };

  const handleSearch = (value) => {
    const { poId, allItems, limit, selectedCategory } = state;

    if (poId === "NO_PO") {
      // Server-side search
      setState(prev => ({ ...prev, search: value, offset: 0, currentPage: 1 }));
      // API call is handled by useEffect
    } else {
      // Client-side search for PO
      // Filter allItems based on value
      let filteredItems = allItems;
      if (value) {
        const lowerValue = value.toLowerCase();
        filteredItems = allItems.filter(item =>
          (item.item && item.item.toLowerCase().includes(lowerValue)) ||
          (item.description && item.description.toLowerCase().includes(lowerValue))
        );
      }

      setState(prev => ({
        ...prev,
        search: value,
        items: filteredItems.slice(0, limit),
        totalCount: filteredItems.length,
        offset: 0,
        currentPage: 1
      }));
    }
  };

  const stockChangeHandler = (e, rowData) => {
    const value = e.target.value;

    // Update displayed items
    const items = _.cloneDeep(state.items);
    const index = items.findIndex(i => i.id === rowData.id);

    if (index === -1) return;

    const item = items[index];

    if (state.poId !== "NO_PO") {
      let enteredValue = !isNaN(parseFloat(value))
        ? parseFloat(value)
        : 0;
      let allowedQty = parseFloat(item.qty) - parseFloat(item.receivedQty);
      if (enteredValue < 0) {
        item.error = "Stock should be greater then 0!";
      } else if (enteredValue > allowedQty) {
        item.error = "You can not enter more than remaining qty";
      } else {
        item.error = false;
      }
    }
    item.newStock = value;

    // Update allItems if in PO mode
    let allItems = state.allItems;
    if (state.poId !== "NO_PO") {
      allItems = _.cloneDeep(state.allItems);
      const allIndex = allItems.findIndex(i => i.id === rowData.id);
      if (allIndex !== -1) {
        allItems[allIndex] = item;
      }
    }

    setState(prev => ({
      ...prev,
      items,
      allItems: state.poId !== "NO_PO" ? allItems : prev.allItems
    }));
  };

  const projectChangeHandler = async (e) => {
    inputChangeHandler(e);
    let vendorsList = await dispatch(getPoVendors(e.target.value, "Supplier")).catch(e => console.error(e));
    let vendors = [];
    Array.isArray(vendorsList) && vendorsList.forEach((vendor) => {
      const isVendorSelected = vendors.find(({ value }) => value === vendor.vendorId);
      if (!isVendorSelected) {
        vendors.push({
          key: idx(vendor, (_) => _.vendor.business_name) || "",
          value: idx(vendor, (_) => _.vendor.id) || "",
        });
      }
    });

    vendors = sortByKeyAsc(vendors);

    setFields(prev => ({
      ...prev,
      vendor: { ...prev.vendor, items: vendors, value: '' },
    }));
  };

  const vendorChangeHandler = async (e) => {
    inputChangeHandler(e);
    let { list: poList } = await dispatch(getPOList({
      vendorId: e.target.value,
      projectId: idx(fields, (_fields) => _fields.project.value),
    })).catch(e => console.error(e));

    let POs = [];
    Array.isArray(poList) && poList.forEach((po) => {
      POs.push({
        key: po.id,
        value: po.u_id,
        items: po.items,
      });
    });

    POs = _.orderBy(POs, ["key"], ["desc"]);
    POs.unshift({ key: "No PO", value: "NO_PO" });
    POs.unshift({ key: "Internal PO", value: "DE_PO" });

    setFields(prev => ({
      ...prev,
      po: { ...prev.po, items: POs, value: '' },
      category: { ...prev.category, value: '' },
      dePurchaseOrder: { ...prev.dePurchaseOrder, value: '' },
      location: { ...prev.location, value: '' },
    }));

    setState(prev => ({ ...prev, selectedCategory: '' }));
  };

  const cancelHandler = () => {
    navigate(`/${INVENTORY}`);
  };

  const submitForm = () => {
    // For PO mode, use allItems to submit ALL entered stock, not just visible page
    const items = state.poId !== "NO_PO" ? state.allItems : state.items;
    const { poId } = state;

    let isFormValid = true;
    let _fields = _.cloneDeep(fields)
    for (let key in _fields) {
      const { error, valid } = handleValidation(_fields[key], _fields[key].validation);
      _fields[key].touched = true;
      _fields[key].valid = valid;
      _fields[key].error = error;
      isFormValid = isFormValid && valid;
    }
    Array.isArray(items) && items.forEach((item) => {
      if (item.error) {
        isFormValid = false;
      }
    });

    if (!isFormValid) {
      setFields(_fields)
    } else {
      // Filter items that have newStock entered
      const itemsToSubmit = items.filter(item => item.newStock && parseFloat(item.newStock) > 0);

      if (itemsToSubmit.length === 0) {
        dispatch(warningSnackBar("Please enter stock for at least one item"));
        return;
      }

      const data = {
        items: itemsToSubmit,
        allocationLocation: _fields.location.value,
        poId: "" + poId,
        transactionType: "RECEIVED",
      };
      if (_fields.location.value === "SITE") {
        const projectData = _fields.project.items.find((project) => project.value === _fields.project.value);
        if (!projectData) {
          dispatch(warningSnackBar("Please Select Project for Delivery Location"));
          return;
        }
        data.allocateToName = projectData.key;
        data.allocateToId = projectData.value;
      } else {
        data.allocateToName = user.name;
        data.allocateToId = user.id;
      }

      if (poId === "NO_PO") {
        dispatch(addNoPoStock(data)).then((res) => {
          cancelHandler();
        }).catch(e => console.error(e));
      } else if (poId === "DE_PO") {
        data.items = formatItems(itemsToSubmit);
        data.poId = "" + idx(_fields, (_) => _.dePurchaseOrder.value);
        const DE_PO_Id = _fields.dePurchaseOrder.value;
        dispatch(updatePOStock(data, DE_PO_Id)).then((res) => {
          cancelHandler();
        }).catch(e => console.error(e));
      } else {
        data.items = formatItems(itemsToSubmit);
        dispatch(updatePOStock(data, poId)).then((res) => {
          cancelHandler();
        }).catch(e => console.error(e));
      }
    }
  };

  const formatItems = (items) => {
    Array.isArray(items) && items.forEach((item) => {
      const newStock = !isNaN(parseFloat(item.newStock)) ? parseFloat(item.newStock) : 0;
      const receivedQty = !isNaN(parseFloat(item.receivedQty)) ? parseFloat(item.receivedQty) : 0;
      item.receivedQty = newStock + receivedQty;
    });
    return items;
  };

  const getColumns = () => {
    const columns = [
      { title: "Item", field: "item" },
    ];

    if (state.poId !== "NO_PO") {
      columns.push(
        { title: "Ordered Quantity", field: "qty" },
        { title: "Received Quantity", field: "receivedQty" },
        {
          title: "Quantity Left",
          field: "qtyLeft",
          render: (rowData) => parseFloat(rowData.qty) - parseFloat(rowData.receivedQty)
        }
      );
    }

    columns.push({
      title: "Enter New Stock",
      field: "newStock",
      render: (rowData) => {
        // Find index in current items array
        return (
          <CustomInput
            className="input-block-sm"
            value={rowData.newStock}
            lable="Stock"
            type="number"
            valid={!rowData.error}
            touched
            error={rowData.error}
            onChange={(e) => stockChangeHandler(e, rowData)}
          />
        );
      }
    });

    return columns;
  };

  return (
    <div className="purchase-order-block">

      <h2 className="content-heading text-uppercase">Add Stock</h2>
      <div className="col-12 breadcrumb-block p-0">
        <Breadcrumb>
          <Breadcrumb.Item onClick={cancelHandler}>INVENTORY</Breadcrumb.Item>
          <Breadcrumb.Item active>Add Stock</Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <div className="row">

        <div className="col-lg-4 mt-3">
          <SelectInput
            {...fields.project}
            label={"Project"}
            onChange={(e) => projectChangeHandler(e)}
          />
        </div>
        <div className="col-lg-4 mt-3">
          <SelectInput
            {...fields.vendor}
            label={'Select Vendor'}
            onChange={(e) => vendorChangeHandler(e)}
          />
        </div>

        <div className="col-lg-4 mt-3">
          <SelectInput
            {...fields.po}
            label={'Select PO'}
            onChange={(e) => changePOType(e)}
          />
        </div>
        {state.poId === "NO_PO" && (<div className="col-lg-4 mt-3">
          <SelectInput
            onChange={(e) => changeCategory(e)}
            {...fields.category}
            label={'Select Catalog'}
          />
        </div>)}
        {state.poId === "DE_PO" && (<div className="col-lg-4 mt-3">
          <SelectInput
            {...fields.dePurchaseOrder}
            label={'Select DE Purchase Order'}
            onChange={(e) => changeDePo(e)}
          />
        </div>)}
        <div className="col-lg-4 mt-3">
          <SelectInput
            {...fields.location}
            label={'Store Location'}
            onChange={(e) => inputChangeHandler(e)}
          />
        </div>

      </div>
      <div className="material-list-block mt-3 add-stock-table">
        <CustomTable
          columns={getColumns()}
          data={state.items}
          fileName='Stock Items'
          itemsPerPage={state.limit}
          limit={state.limit}
          currentPage={state.currentPage}
          paginationCount={state.totalCount}
          pageHandler={handlePageChange}
          limitChangeHandler={handleLimitChange}
          isLoading={state.isLoading}
          isAction={false}
          searchHandler={handleSearch}
        />
      </div>


      <div className="col-12 d-flex justify-content-end gap-3 mt-3">
        {props.writePermission && (<Button onClick={submitForm} className="secondarybtn">DONE</Button>)}
        <Button onClick={cancelHandler} className="secondarybtn cancelbtn">CANCEL</Button>
      </div>
    </div>
  );

}
